export const environment = {
    production: true,
    profile: 'superefectivo',
    api_base_url: 'https://se-bb.fixnet.it',
    google_api_key: '6LcXvaYZAAAAABtPJX1F4go1UEokZO2tC-1L4ZcE',
    credits: 'SuperEfectivo S. L. Inscrita en el Registro mercantil de Madrid, Folio 48, Tomo 22839, Sección 8, Hoja 52454, Inscripción 1a-C.I.F.B -84688399. Derechos reservados.',
    links: {
        home: 'https://www.superefectivo.com/',
        compro_oro: 'https://www.superefectivo.com/servicios/valoraciones-oro',
        venta_recuperable: 'https://www.superefectivo.com/servicios/venta-recuperable',
        sostenibilidad: 'https://www.superefectivo.com/sostenibilidad',
        faq: 'https://www.superefectivo.com/preguntas-frecuentes',
        legal: 'https://www.superefectivo.com/aviso-legal',
        privacy_policy: 'https://www.superefectivo.com/politica-privacidad',
        cookie_policy: 'https://www.superefectivo.com/politica-de-cookies',
        claims_policy: 'https://www.superefectivo.com/politica-de-reclamaciones'
    }
};
